import { render, staticRenderFns } from "./innerMongolia_home.vue?vue&type=template&id=461705ae&scoped=true&"
import script from "./innerMongolia_home.vue?vue&type=script&lang=js&"
export * from "./innerMongolia_home.vue?vue&type=script&lang=js&"
import style0 from "./innerMongolia_home.vue?vue&type=style&index=0&id=461705ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461705ae",
  null
  
)

export default component.exports